var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.611,
    height: 20.5,
    viewBox: "0 0 22.611 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon-material-business",
    d: "M11.444,18.222V17.167H4.066l-.011,4.222A2.1,2.1,0,0,0,6.167,23.5H20.944a2.1,2.1,0,0,0,2.111-2.111V17.167H15.667v1.056ZM22,8.722H17.767V6.611L15.656,4.5H11.434L9.323,6.611V8.722H5.111A2.117,2.117,0,0,0,3,10.833V14a2.1,2.1,0,0,0,2.111,2.111h6.333V14h4.222v2.111H22A2.117,2.117,0,0,0,24.111,14V10.833A2.117,2.117,0,0,0,22,8.722Zm-6.333,0H11.444V6.611h4.222Z",
    transform: "translate(-2.25 -3.75)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/Business.7e6a7208a17d02c9f669ce4c53aacbd5.svg";
export { ForwardRef as ReactComponent };